export default "__VITE_ASSET__BK3UQONq__"